import { Permission } from "./permission.model";

export class ApplicationPermissions {
    constructor(public roles: string[], public permissions: Permission[]) {
        
    }
}